import React, { Fragment, useState, useEffect } from "react";
import { FilterIcon, XIcon } from "@heroicons/react/outline";
import DropDownComponent from "../../questions/metadataDropDownList";
import { ResetIcon } from "../../../../assets/icons";
import { connect } from "react-redux";
import {
  getSubjectByStateAndGrade,
  getStateAll,
  getGradeAll,
  getSubject,
} from "../../../../api/subject.service";
import {
  ILiftOffGalaxyStandard,
  ILiftOffGalaxyTopic,
} from "../../../../model/interface/liftOffGalaxyStandard";
import { IStandard } from "../../../../model/interface/standard";
import { getAllDomainsBySubject } from "../../../../api/domain.service";
import { getStandards } from "../../../../api/standard.service";
import { IDropDown } from "../../../../model/shared/dropDown";
import Loader from "../../../shared/loader/loader";
import Constant from "../../../../utils/constant";
import { getLiftOffGalaxyStandard } from "../../../../api/liftOffGalaxyStandard.service";
import Select, { SingleValue } from "react-select";
import { DropdownItem } from "../../../../model/interface/keyValuePair";

interface TopicPopupProps {
  liftOffHeaderId: number;
  liftOffGalaxyId: number;
  orderNumber: number;
  profile: any;
  handleAddTopic: (data: Array<ILiftOffGalaxyStandard>) => void;
  availableStates: Array<number>;
  availableGrades: Array<number>;
  selectedContentId: number;
}

const StandardTab = (props: TopicPopupProps) => {
  const defaultPageNumber = 1;
  const defaultDropDownValue: DropdownItem = {
    label: "",
    value: "0",
  };

  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedStandardIds, setSelectedStandardIds] = useState<Array<number>>(
    []
  );
  const [states, setStates] = useState<Array<IDropDown>>([]);
  const [gradeSubjects, setGradeSubjects] = useState<Array<IDropDown>>([]);
  const [domains, setDomains] = useState<Array<IDropDown>>([]);
  const [standards, setStandards] = useState<Array<IStandard>>([]);
  const [grades, setGrades] = useState<Array<IDropDown>>([]);
  const [selectedState, setSelectedState] =
    useState<DropdownItem>(defaultDropDownValue);
  const [selectedGrade, setSelectedGrade] =
    useState<DropdownItem>(defaultDropDownValue);
  const [selectedSubject, setSelectedSubject] =
    useState<DropdownItem>(defaultDropDownValue);
  const [selectedDomain, setSelectedDomain] =
    useState<DropdownItem>(defaultDropDownValue);

  const [existingGalaxyStandards, setExistingGalaxyStandards] = useState<
    Array<ILiftOffGalaxyTopic>
  >([]);

  useEffect(() => {
    getExistingGalaxyStandards();
  }, []);

  useEffect(() => {
    if (states.length === 0) {
      bindStateData();
    }

    if (grades.length === 0) {
      bindGradeData();
    }

    if (selectedState.value !== "0" && selectedGrade.value !== "0") {
      bindSubjectsData();
    }

    if (selectedSubject.value !== "0") {
      bindDomainsData();
    }
  }, [selectedState.value, selectedGrade.value, selectedSubject.value]);

  const getExistingGalaxyStandards = () => {
    getLiftOffGalaxyStandard(
      props.liftOffHeaderId,
      props.liftOffGalaxyId,
      false,
      1,
      99999
    ).then((r) => {
      setExistingGalaxyStandards(r.data.data);
    });
  };

  const bindStateData = () => {
    async function stateReload() {
      setLoading(true);
      const response = getStateAll(100, 1);

      const data = (await response).data;
      let stateDDLData = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.stateId,
        };
      });
      stateDDLData = stateDDLData.filter(
        (item) => props.availableStates.indexOf(item.value) !== -1
      );
      setStates(stateDDLData);
      setLoading(false);
    }
    stateReload();
  };

  const bindGradeData = () => {
    async function gradeReload() {
      setLoading(true);
      const response = getGradeAll(100, defaultPageNumber);

      const data = (await response).data;
      if (data.data.length > 0) {
        data.data.sort(
          (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
        );
        let dropdownData = data.data.map((eachGradeData) => {
          return {
            value: eachGradeData.gradeId || 0,
            label: `${eachGradeData.name}`,
          };
        });
        dropdownData = dropdownData.filter(
          (item) => props.availableGrades.indexOf(item.value) !== -1
        );
        setGrades(dropdownData);
      }

      setLoading(false);
    }
    gradeReload();
  };

  const bindSubjectsData = () => {
    async function subjectReload() {
      setLoading(true);
      const params = {
        name: "",
        contentAreaId: props.selectedContentId || 0,
        stateId: parseInt(selectedState.value) || 0,
        gradeId: parseInt(selectedGrade.value) || 0,
        gradeLevel: "",
        orderbyColumn: "name",
        sortDir: "asc",
        pageSize: 100,
        pageNumber: 1,
        isActive: true,
        isApproved: true,
        subjectTypeId: Constant.SubjectType.PL,
      };

      const response = getSubject(params);
      const data = (await response).data;
      const subjectDDLData = data.data.map((values: any) => {
        return {
          label: values?.name,
          value: values?.subjectId,
        };
      });
      setGradeSubjects(subjectDDLData);
      setLoading(false);
    }
    subjectReload();
  };

  const bindDomainsData = () => {
    setLoading(true);
    getAllDomainsBySubject(parseInt(selectedSubject.value), 100, 1).then(
      (res) => {
        const domainDDLData = res.data.data.map((values: any) => {
          return {
            label: values?.name,
            value: values?.domainId,
          };
        });
        setDomains(domainDDLData);
        setLoading(false);
      }
    );
  };

  const bindStandardData = () => {
    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: selectedDomain.value,
      code: "",
      isActive: true,
      description: "",
      loadOrder: 0,
      pageSize: 100,
      pageNumber: 1,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    getStandards(standard).then((res: any) => {
      const standardData = res.data.data;

      if (standardData && standardData.length > 0) {
        const existingStandardIds = existingGalaxyStandards?.map(
          (standard) => standard.standardId
        );

        const data = standardData.filter((standard) => {
          return !existingStandardIds.includes(standard.standardId);
        });

        setStandards(data);
      }
    });
  };

  const handleStateChange = (state: SingleValue<DropdownItem> | null) => {
    if (state) {
      setSelectedState(state);
    }
  };

  const handleSubjectChange = (subject: SingleValue<DropdownItem> | null) => {
    if (subject) {
      setSelectedSubject(subject);
    }
  };

  const handleDomainChange = (domain: SingleValue<DropdownItem> | null) => {
    if (domain) {
      setSelectedDomain(domain);
    }
  };

  const handleGradeChange = (grade: SingleValue<DropdownItem> | null) => {
    if (grade) {
      setSelectedGrade(grade);
    }
  };

  const handleSetSelectedStandards = (standardId: number) => {
    setSelectedStandardIds((prev) => {
      if (prev.includes(standardId)) {
        return prev.filter((x) => x !== standardId);
      } else {
        return [...prev, standardId];
      }
    });
  };

  const handleFilter = () => {
    if (selectedDomain.value !== "0") {
      bindStandardData();
    }
  };

  const validate = () => {
    let isValid = true;
    if (selectedStandardIds.length === 0) {
      isValid = false;
    }
    return isValid;
  };

  const handleAddTopic = () => {
    if (validate()) {
      const liftOffGalaxyStandards: Array<ILiftOffGalaxyStandard> = [];

      selectedStandardIds.map((standardId, index) => {
        const liftOffGalaxyStandard: ILiftOffGalaxyStandard = {
          liftOffHeaderId: props.liftOffHeaderId,
          standardId: standardId,
          liftOffGalaxyId: props.liftOffGalaxyId,
          orderNumber: props.orderNumber + index,
          isActive: true,
          isStandardGrouped: false,
          createdByUserId: props.profile?.userId,
          updatedByUserId: props.profile?.userId,
        };
        liftOffGalaxyStandards.push(liftOffGalaxyStandard);
      });

      props.handleAddTopic(liftOffGalaxyStandards);
      handleResetFilter();
    }
  };

  const handleResetFilter = () => {
    setResetDropdownFlag(!resetDropdownFlag);
    setGrades([]);
    setSelectedStandardIds([]);
    setStandards([]);
    setSelectedDomain(defaultDropDownValue);
    setSelectedSubject(defaultDropDownValue);
    setSelectedGrade(defaultDropDownValue);
  };

  return (
    <Fragment>
      {loading && <Loader />}
      <div className={" pb-6"}>
        <div
          className={
            "grid sm:grid-cols-4 md:grid-cols-8  xl:grid-cols-12 gap-4 text-sm"
          }
        >
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>State</div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedState}
                  onChange={handleStateChange}
                  options={states?.map((state) => ({
                    value: state.value.toString(),
                    label: state.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>Grade</div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedGrade}
                  onChange={handleGradeChange}
                  options={grades?.map((grade) => ({
                    value: grade.value.toString(),
                    label: grade.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>
              Subject
            </div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedSubject}
                  onChange={handleSubjectChange}
                  options={gradeSubjects?.map((gradeSubject) => ({
                    value: gradeSubject.value.toString(),
                    label: gradeSubject.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-span-4">
            <div className={"self-center place-self-srt col-span-2"}>
              Domain
            </div>
            <div className={"w-full mt-1"}>
              <div className="mt-1">
                <Select
                  value={selectedDomain}
                  onChange={handleDomainChange}
                  options={domains?.map((domain) => ({
                    value: domain.value.toString(),
                    label: domain.label,
                  }))}
                  className="text-gray-900 cursor-default select-none relative py-2"
                  isSearchable={true}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      background:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#1A1C23"
                          : "white",
                      borderColor:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6B7280"
                          : "#D1D5DB",
                      borderWidth: "1px",
                      "&:hover": {
                        borderColor:
                          state.isFocused &&
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6b7280"
                            : state.isFocused
                            ? "#4c5563"
                            : "",
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "#374051",
                    }),
                    input: (base) => ({
                      ...base,
                      color:
                        document.getElementsByClassName("dark")?.length > 0
                          ? "white"
                          : "",
                    }),
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-span-4">
            <button
              className={`mt-6 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg
                    ${selectedDomain.value !== "0" ? "" : " opacity-50"} `}
              type="button"
              onClick={() => {
                handleFilter();
              }}
            >
              <FilterIcon className="w-3 h-3"></FilterIcon>
              Filter
            </button>
          </div>
        </div>

        <div id="dataContainer" className="mt-4">
          <div className="flex flex-col mt-1">
            <div className="-my-2  sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow  border-b border-gray-200 sm:rounded-lg">
                  <div className="flex flex-col h-60">
                    <div className="flex-grow overflow-auto rounded-lg">
                      <table className="relative  min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color sticky top-0">
                          <tr>
                            <th
                              scope="col"
                              className="sticky top-0  px-3 py-2 w-10 font-light text-sm text-left text-white tracking-wider"
                            ></th>
                            <th
                              scope="col"
                              className="sticky top-0  px-3 py-2 w-28 font-light text-sm text-left text-white tracking-wider"
                            >
                              Code
                            </th>
                            <th
                              scope="col"
                              className="sticky top-0  px-3 py-2 w-35 font-light text-sm text-left text-white tracking-wider"
                            >
                              Standard
                            </th>
                            <th
                              scope="col"
                              className="sticky top-0  px-3 py-2  font-light text-sm text-left text-white tracking-wider"
                            >
                              Description
                            </th>
                          </tr>
                        </thead>
                        <tbody className="z-10">
                          {standards.map((standard) => (
                            <tr key={standard.standardId}>
                              <td className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider">
                                <div>
                                  <input
                                    id={standard.standardId.toString()}
                                    name={standard.standardId.toString()}
                                    type="checkbox"
                                    checked={selectedStandardIds.includes(
                                      standard.standardId
                                    )}
                                    onChange={(e) => {
                                      handleSetSelectedStandards(
                                        standard.standardId
                                      );
                                    }}
                                    className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                  />
                                </div>
                              </td>
                              <td className="px-3 py-2">{standard.code}</td>
                              <td className="px-3 py-2">{standard.name}</td>
                              <td className="px-3 py-2">
                                {standard.description}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {standards.length === 0 && (
                        <p className="p-2">No Records Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" flex justify-end  mt-4">
          <button
            className={`mt-4 inline-flex items-center text-sm text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg
                  ${selectedStandardIds.length > 0 ? "" : "opacity-50"}
                  `}
            type="button"
            onClick={() => {
              handleAddTopic();
            }}
          >
            Add Standard
          </button>
          <button
            type="button"
            className=" hidden mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
            onClick={() => {
              handleResetFilter();
            }}
          >
            <ResetIcon className="w-3 h-3"></ResetIcon>
            <span>Reset Filter</span>
          </button>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(StandardTab);
